module.exports = __webpack_public_path__ + "img/01.32fa3bfc.jpg";